import React, { useState, useEffect } from 'react';
import {
    empty
} from '__globals/global-functions';
import {
    getJsonContent, getJsonResultCopy,
    setContent
} from "__globals/copy-functions";
import * as GC from "../../__globals/GLOBAL-CONSTANTS";

export const ThankYouCopy = props => {

    // PROMOTION VARIABLES


    // LOCAL VARIABLES
    const [currentResultScreen, setCurrentResultScreen] = useState(undefined);

    const [showTitle, setShowTitle] = useState(false);
    const [showCopy, setShowCopy] = useState(true);
    const [showResultCopy, setShowResultCopy] = useState(true);

    /** SET THE CURRENT RESULT SCREEN **/
    useEffect(() => {
        if ( !empty(props.promotion) && !empty(props.gameClaim) ) {
            if ( !empty( props.gameClaim?.parameters.thankYouScreen ) ) {
                setCurrentResultScreen( props.gameClaim?.parameters.thankYouScreen );
            }
        }
    }, [props.promotion, props.gameClaim]);

    /** GET BOOLEAN AND COPY **/
    useEffect(() => {
        if (!empty(currentResultScreen)) {
            setShowTitle( currentResultScreen.showTitle );
            setShowCopy( currentResultScreen.showCopy );
            setShowResultCopy( currentResultScreen.showResultCopy );
        }
    }, [currentResultScreen]);
    useEffect(() => {
        if (showTitle && !empty(props.promotion)) {
            let titleCopy = getJsonContent(props.promotion, props.jsonKey, "title", "<h2>DEFAULT TITLE</h2>", props.entry );
            setContent("result_title_copy", titleCopy);
        }
    }, [showTitle]);
    useEffect(() => {
        if (showCopy && !empty(props.promotion)) {
            let copyCopy = getJsonContent(props.promotion, props.jsonKey, "copy", "<h2>DEFAULT COPY</h2>", props.entry );
            setContent("result_general_copy", copyCopy);
        }
    }, [showCopy]);
    useEffect(() => {
        if ( showResultCopy && !empty(props.promotion) && !empty(props.gameClaim) ) {
            let resultCopy = getJsonResultCopy(props.promotion, props.jsonKey, props.gameClaim, "<h2>ERROR</h2>", props.entry );
            setContent("result_specific_copy", resultCopy);
        }
    }, [showResultCopy]);
    /** END GET BOOLEAN AND COPY **/


    return (
        <React.Fragment>
            {showTitle && <div id="result_title_copy">Result General Title</div>}
            {showCopy && <div id="result_general_copy">Result General Copy</div>}
            {showResultCopy && <div id="result_specific_copy">Result Specific Copy</div>}
        </React.Fragment>
    );
}